import { Component, ElementRef, output, viewChild, input, InputSignal, Signal, OutputEmitterRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'cancel-button',
	templateUrl: './cancel-button.component.html',
	styleUrls: ['./cancel-button.component.scss'],
	imports: [MatTooltipModule, MatIconModule, TranslatePipe]
})
export class CancelButtonComponent {
	readonly matIconContainer: Signal<ElementRef<any>> = viewChild<ElementRef>('matIconContainer');
	readonly disabled: InputSignal<boolean> = input<boolean>(undefined);
	readonly onClick: OutputEmitterRef<Event> = output<Event>();

	public isFocus: boolean;
	public isToolTipDisabled: boolean;
	public readonly tooltip: string = 'BUTTONS_TOOLTIP.CANCEL';

	public setFocusStatus(isFocus: boolean) {
		this.isFocus = isFocus;
		if (!isFocus) {
			this.isToolTipDisabled = false;
		}
	}

	public clicked(event: Event, fromEnterPressed: boolean): void {
		if (this.disabled()) {
			event.stopPropagation();
		} else {
			if (!fromEnterPressed) {
				this.matIconContainer().nativeElement?.blur();
			} else {
				this.isToolTipDisabled = true;
			}
			this.onClick.emit(event);
		}
	}
}
